import { render, staticRenderFns } from "./ExamEventsList.vue?vue&type=template&id=1626db6a&scoped=true"
import script from "./ExamEventsList.vue?vue&type=script&lang=js"
export * from "./ExamEventsList.vue?vue&type=script&lang=js"
import style0 from "./ExamEventsList.vue?vue&type=style&index=0&id=1626db6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626db6a",
  null
  
)

export default component.exports